import axios from "axios";
import { ELEARNING_AUTH_URL } from "../apiConfig";

const register = (username, email, password) => {
  return axios.post(ELEARNING_AUTH_URL + "signup", {
    username,
    email,
    password
  });
};

const login = (username, password) => {
  return axios
    .post(ELEARNING_AUTH_URL + "signin", {
      username,
      password
    })
    .then((response) => {
      if (response.data && response.data.token) {
        localStorage.setItem("elearningUser", JSON.stringify(response.data));
      }
      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("elearningUser");
  return axios.post(ELEARNING_AUTH_URL + "signout");
};

const getCurrentUser = () => {
  try {
    const user = localStorage.getItem("elearningUser");
    return user ? JSON.parse(user) : null;
  } catch (error) {
    return null;
  }
};

const ElearningAuthService = {
  register,
  login,
  logout,
  getCurrentUser
};

export default ElearningAuthService;
